/**
 * Formats a Date object to YYYY-MM-DD string in local timezone
 * This avoids timezone conversion issues that occur with toISOString()
 *
 * @param date - The Date object to format
 * @returns Date string in YYYY-MM-DD format
 */
export function formatDateLocal(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Parses a YYYY-MM-DD string to a Date object in local timezone
 * Sets time to 00:00:00 local time
 *
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date object in local timezone
 */
export function parseDateLocal(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Converts a Date or string to YYYY-MM-DD format in local timezone
 * Handles both Date objects and date strings
 *
 * @param dateInput - Date object or YYYY-MM-DD string
 * @returns Date string in YYYY-MM-DD format
 */
export function toLocalDateString(dateInput: Date | string): string {
  if (typeof dateInput === 'string') {
    return dateInput;
  }
  return formatDateLocal(dateInput);
}
